import React, { useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const DirectGoodsReceiptReport = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/purchasewise");
  };

  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getOpeningStockData } = useHttp();

  const FillReports = () => {
    var d = new Date(selectedToDate);

    d.setDate(d.getDate() + 1);

    var tdate = moment(d).format("DD/MM/YYYY");

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");

    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    var url = `/api/directGoodsReceiptReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getOpeningStockData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReports(0, 0);
  }, [getOpeningStockData]);

  const fieldsToExport = [
    "openingStockDate",
    "openingStockNo",
    "executiveName",
    "vendorName",
    "warehouseName",
    "productName",
    "productSubTypeName",
    "productTypeName",
    "quantity",
    "pricePerUnit",
    "value",
  ];

  const customHeaders = [
    "Date",
    "Doc No",
    "Executive Name",
    "Vendor Name",
    "Warehosue",
    "Product Name",
    "Product Sub Type",
    "Product Type",
    "Quantity",
    "Rate",
    "Total Amount",
  ];

  const handleExportExcel = () => {
    const filename = "DirectGoodsReceiptReport.xlsx";

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Direct Goods Receipt Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReports();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>

              <div className="col-md-3"></div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "1.4rem" }}>
                    <table className="table table-bordered text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th> Date </th>
                          <th> Doc No </th>
                          <th>Executive Name</th>

                          <th> Vendor Name</th>
                          <th> Warehosue</th>
                          <th> Product Name </th>
                          <th> Product Sub Type </th>
                          <th> Product Type </th>
                          <th> Quantity </th>
                          <th> Rate</th>
                          <th> Total Amount </th>
                        </tr>
                      </thead>

                      {currentItems &&
                        currentItems.map((itm, i) => {
                          return (
                            <tr key={i}>
                              <td> {itm.openingStockDate} </td>
                              <td>{itm.openingStockNo}</td>
                              <td>{itm.executiveName}</td>
                              <td>{itm.vendorName}</td>{" "}
                              <td>{itm.warehouseName}</td>
                              <td>{itm.productName}</td>
                              <td>{itm.productSubTypeName}</td>
                              <td>{itm.productTypeName}</td>
                              <td>{itm.quantity} </td>
                              <td>{itm.pricePerUnit}</td>
                              <td>{itm.value} </td>
                            </tr>
                          );
                        })}
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectGoodsReceiptReport;
